import { AppletHostError } from '../../applet-host-error';
import { AppletHostErrorCode } from '../../applet-host-error-code';
import {
    DateRange,
    DurationUnits
} from '@meltwater/date-range';

/**
 * A decorator function to handle the update from @meltwater/date-range v2 to @meltwater/date-range v3
 * All dateRange values will be wrapped in the @meltwater/date-range v3 constructor to ensure they match applet-host v2
 *
 * @private
 * @param {object} options - SEE BELOW
 * @returns {AppletHostInstallOptions} - The decorated appletHostInstallOptions
 */
export function wrapDateRangeRepositoryForDateRangeV3Upgrade({ appletHostInstallOptions }) {
    let updatedAppletHostInstallOptions = {
        ...appletHostInstallOptions
    };

    if (appletHostInstallOptions.dateRangeRepository && appletHostInstallOptions.dateRangeRepository.get) {
        const previousGetMethod = appletHostInstallOptions.dateRangeRepository.get.bind(appletHostInstallOptions.dateRangeRepository);
        const compatibilityWrapperFunction = async function compatibilityWrapper(options) {
            const previousDateRange = await previousGetMethod(options);
            const dateRange = new DateRange(previousDateRange);

            if (dateRange.durationUnit !== DurationUnits.DAYS) {
                throw new AppletHostError({
                    code: AppletHostErrorCode.INVALID_OUTPUT_FROM_REPOSITORY,
                    message: `Cannot return backward-compatible date range for duration unit not supported before AppletHost v2: ${dateRange.durationUnit}`
                });
            }

            return dateRange;
        };

        updatedAppletHostInstallOptions = {
            ...updatedAppletHostInstallOptions,
            dateRangeRepository: {
                ...updatedAppletHostInstallOptions.dateRangeRepository,
                get: compatibilityWrapperFunction
            }
        };
    }

    if (appletHostInstallOptions.dateRangeRepository && appletHostInstallOptions.dateRangeRepository.set) {
        const previousSetMethod = appletHostInstallOptions.dateRangeRepository.set.bind(appletHostInstallOptions.dateRangeRepository);

        const compatibilityWrapperFunction = function compatibilityWrapper(dateRange, namespace) {
            const wrappedDateRange = new DateRange(dateRange);

            if (wrappedDateRange.durationUnit !== DurationUnits.DAYS) {
                throw new AppletHostError({
                    code: AppletHostErrorCode.FEATURE_NOT_SUPPORTED,
                    message: `Cannot set backward-compatible date range for duration unit not supported before AppletHost v2: ${dateRange.durationUnit}`
                });
            }

            previousSetMethod(wrappedDateRange, namespace);
        };

        updatedAppletHostInstallOptions = {
            ...updatedAppletHostInstallOptions,
            dateRangeRepository: {
                ...updatedAppletHostInstallOptions.dateRangeRepository,
                set: compatibilityWrapperFunction
            }
        };
    }
    return updatedAppletHostInstallOptions;
}
